import type React from 'react'

/**
 * Click handler for an in-row link whose table row also navigates on click.
 *
 * The click never reaches the row (`stopPropagation`), otherwise a Ctrl/Cmd/
 * Shift-click would open a new tab natively AND navigate the current tab via
 * the row handler. A plain click is routed in-app; a modified click is left to
 * the browser.
 */
export function handleRowLinkClick(
  event: React.MouseEvent<HTMLAnchorElement>,
  navigate: () => void
) {
  event.stopPropagation()
  if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return
  event.preventDefault()
  navigate()
}
